import React from 'react'

export const doc_styles = theme => ({
    title_text: {
        color: 'white', 
        position: "fixed", 
        top: "87px", 
        left: "85px", 
        zIndex: "1030", 
        fontWeight: "bold",
      "@media (max-width: 1200px)": {
        top: '135px'
      },
    },
    report_block: {
display: "table",
marginBottom: "20px",
position: "fixed",
zIndex: "500000",
right: "2px",
 top: "102px",
 background:'#fff',
 boxShadow:'rgba(149, 157, 165, 0.2) 0px 8px 24px',
//  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
"@media (max-width: 1200px)": {
  top: '135px'
},
    },
    report_box: {
      width: "25%",
      background: "url(./list_icon.png) no-repeat",
      backgroundSize: "35px",
      backgroundPosition: "50% 0",
      padding: "50px 15px 0 15px",
      color: "#fff",
      display: "block",
      textAlign: "center",
      fontSize: "0.7em",
      boxShadow: "1px 0px 0 #fff",
      float: "left"
    },
    report_title: {
      fontSize: "1em",
      color: "#000",
      textAlign: "center",
      fontWeight: "700",
      // margin: "0 20px 20px 0",
      cursor: "pointer",
      // width:180,
      padding:'10px 10px 2px 15px'
      
    },
    

  });